module.exports = __webpack_public_path__ + "static/img/logo.9737160c.png";